<div class="container">
  <nz-date-picker
    nzBorderless
    [nzDisabled]="disabled"
    [nzAllowClear]="nzAllowClear"
    [nzMode]="antDatePickerMode()"
    [(ngModel)]="date"
    (ngModelChange)="onChange($event)"></nz-date-picker>
  <span class="zone">{{ getZoneShortName() }}</span>
</div>
